<template>
  <el-row>
    <el-card class="box-card" shadow="hover">
      <div slot="header" class="clearfix" style="border: none">
        <i class="el-icon-card-header"></i>
        <span>患者</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-card class="el-card-small">
            <el-row>
              <el-col :span="7" class="numClass" style="color:green">
                <img src="@/assets/admin/admin_19.png"/>
              </el-col>
              <el-col :span="9">
                <el-row class="numClass" style=" color: #ED2C43;">
                  <CountTo :startVal="0.8 * Number(patient.patient_cnt)"
                           :endVal="Number(patient.patient_cnt)"
                           :duration="changeSlow"></CountTo>
                </el-row>
                <el-row :span="24" class="hintClass">患者数量</el-row>
              </el-col>
              <el-col :span="8" style="margin-right: 0px">
                <el-row class="numClass-small" style="color: #ED2C43;">▲{{
                    patient.patient_tongbi_ratio
                  }}
                </el-row>
                <el-row :span="24" class="hintClass-small">同比</el-row>
              </el-col>
            </el-row>
            <LineChart id="patient_trend_cum"
                       :area_color="'#86F234'"
                       height="120px"
                       width="100%"
                       :show_mode="'simple'"
                       path="patient_trend_cum"></LineChart>
          </el-card>
        </el-col>

        <el-col :span="6">
          <el-card class="el-card-small">
            <el-row>
              <el-col :span="5" class="numClass" style="color:green">
                <img src="@/assets/admin/admin_18.png"/>
              </el-col>
              <el-col :span="8">
                <el-row class="numClass" style=" color: #ED2C43;">占比</el-row>
                <el-row :span="24" class="hintClass">各性别患者</el-row>
              </el-col>
              <el-col :span="11" style="margin-right: 0px">
                <el-row class="numClass-small" style="color: #ED2C43;font-size: 15px;line-height: 18px;">
                  男性：{{ patient.patient_male_ratio }}
                </el-row>
                <el-row class="numClass-small" style="color: #ED2C43;font-size: 15px;line-height: 18px;">
                  女性：{{ patient.patient_female_ratio }}
                </el-row>
              </el-col>
            </el-row>
            <el-row>
              <PieChart id="patient_gender_pie11"
                        height="120px"
                        width="100%"
                        :show_mode="'simple'"
                        path="patient_gender_pie"></PieChart>
            </el-row>
          </el-card>
        </el-col>

        <el-col :span="6">
          <el-card class="el-card-small">
            <el-row>
              <el-col :span="5" class="numClass" style="color:green">
                <img src="@/assets/admin/admin_17.png"/>
              </el-col>
              <el-col :span="8">
                <el-row class="numClass" style=" color: #ED2C43;">占比</el-row>
                <el-row :span="24" class="hintClass">各年龄患者</el-row>
              </el-col>
              <el-col :span="11" style="margin-right: 0px">
                <el-row class="numClass-small" style="color: #ED2C43;font-size: 15px;line-height: 18px;">
                  儿童：{{ patient.patient_child_ratio }}
                </el-row>
                <el-row class="numClass-small" style="color: #ED2C43;font-size: 15px;line-height: 18px;">
                  老年人：{{ patient.patient_aged_ratio }}
                </el-row>
              </el-col>
            </el-row>
            <el-row>
              <PieChart id="patient_age_pie11"
                        height="120px"
                        width="100%"
                        :show_mode="'simple'"
                        path="patient_age_pie"></PieChart>
            </el-row>
          </el-card>
        </el-col>

        <el-col :span="6">
          <el-card class="el-card-small">
            <el-row>
              <el-col :span="5" class="numClass" style="color:green">
                <img src="@/assets/admin/admin_18.png"/>
              </el-col>
              <el-col :span="8">
                <el-row class="numClass" style=" color: #ED2C43;">占比</el-row>
                <el-row :span="24" class="hintClass">复诊率</el-row>
              </el-col>
              <el-col :span="11" style="margin-right: 0px">
                <el-row class="numClass-small" style="color: #ED2C43;font-size: 15px;line-height: 18px;">
                  比例：{{ patient.patient_revisit_ratio }}
                </el-row>
              </el-col>
            </el-row>
            <el-row>
              <PieChart id="chronic_disease_stat_pie1"
                        height="120px"
                        width="100%"
                        :show_mode="'simple'"
                        path="chronic_disease_stat_pie">
              </PieChart>
            </el-row>
          </el-card>
        </el-col>
      </el-row>
    </el-card>
  </el-row>
</template>

<script>
import LineChart from "@/views/charts/line";
import PieChart from "@/views/charts/pie";
import CountTo from "vue-count-to";

export default {
  name: "PatientReportSection",
  components: {
    LineChart,
    PieChart,
    CountTo,
  },
  props: {
    // 患者统计数据，保持与旧页面一致
    patient: {
      type: Object,
      default: () => ({}),
    },
    // 计数动画时长，沿用原始业务逻辑
    changeSlow: {
      type: Number,
      default: 5000,
    },
  },
};
</script>
<style scoped src="./list.css"></style>
